"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "venegono-inferiore": {
    "83f2361b": [{
      "hkey": "0156dacb",
      "slug": "venegono-inferiore",
      "name": "Venegono Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "seminario-pio-xi": [{
      "hkey": "0156dacb",
      "slug": "venegono-inferiore",
      "name": "Venegono Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8ba6b538": [{
      "hkey": "0156dacb",
      "slug": "venegono-inferiore",
      "name": "Venegono Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "ugona": [{
      "hkey": "0156dacb",
      "slug": "venegono-inferiore",
      "name": "Venegono Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;